var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 53,
    viewBox: "0 0 80 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_616_3385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.3138 20.1285C68.6645 10.93 60.981 3.6253 51.6202 3.6253C48.6983 3.6253 45.8576 4.35577 43.3145 5.73554C39.3916 2.11025 34.1971 0 28.7862 0C16.9905 0 7.41321 9.57727 7.41321 21.373C7.41321 22.5364 7.52143 23.6997 7.71081 24.863C3.1386 27.1627 0.0273438 31.8972 0.0273438 37.3622C0.0273438 45.0727 6.30398 51.3493 14.0145 51.3493H23.5106V45.9384H14.0145C9.27996 45.9384 5.43823 42.0967 5.43823 37.3622C5.43823 32.6277 9.27996 28.7859 14.0145 28.7859C14.258 28.7859 14.4744 28.84 14.6909 28.8671C13.5005 26.6486 12.8241 24.1055 12.8241 21.4001C12.8241 12.5803 19.9665 5.43794 28.7862 5.43794C34.6029 5.43794 39.6892 8.57626 42.4758 13.2296C44.7213 10.7136 47.9949 9.09029 51.6202 9.09029C58.4379 9.09029 63.9299 14.6094 63.9299 21.4001C63.9299 22.5634 63.7135 23.6456 63.4159 24.7007C63.5782 24.7007 63.7406 24.6466 63.9299 24.6466C69.8008 24.6466 74.5623 29.4082 74.5623 35.279C74.5623 41.1498 69.8008 45.9384 63.9299 45.9384H56.517V51.3493H63.9299C72.7767 51.3493 79.9732 44.1529 79.9732 35.279C79.9732 28.299 75.5093 22.374 69.2867 20.1556L69.3138 20.1285Z",
    fill: "#0076FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0149 21.2107C40.7714 20.9131 40.3927 20.7507 40.0139 20.7507C39.6351 20.7507 39.2564 20.9131 39.0129 21.2107L28.0829 33.6286C27.7312 34.0345 27.65 34.6026 27.8665 35.0896C28.0829 35.5766 28.5699 35.8742 29.111 35.8742H35.604V50.8353C35.604 51.5928 36.1992 52.188 36.9568 52.188H43.1252C43.8827 52.188 44.4779 51.5928 44.4779 50.8353V35.8742H50.998C51.7555 35.8742 52.3507 35.279 52.3507 34.5214C52.3507 34.0615 52.1343 33.6557 51.7555 33.4122L41.042 21.2377L41.0149 21.2107Z",
    fill: "#0076FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_616_3385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 52.188,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUpload);
export default __webpack_public_path__ + "static/media/ico-upload.e6923c756deb284ce89be2b949892589.svg";
export { ForwardRef as ReactComponent };